"use client";

// NOTE: this is a workaround to get Emotion to work properly with Next.js and App Router so there aren't hydration mismatches; see this issue for more context and the source of the snippet: https://github.com/chakra-ui/chakra-ui/discussions/9051#discussioncomment-16326920
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { useServerInsertedHTML } from "next/navigation";
import type React from "react";
import { useState } from "react";
export default function EmotionRegistry({
  children
}: {
  children: React.ReactNode;
}) {
  const [{
    cache: cache_0,
    flush: flush_0
  }] = useState(() => {
    const cache = createCache({
      key: "css"
    });
    cache.compat = true;
    const prevInsert = cache.insert;
    let inserted: string[] = [];
    cache.insert = (...args) => {
      const serialized = args[1];
      if (cache.inserted[serialized.name] === undefined) {
        inserted.push(serialized.name);
      }
      return prevInsert(...args);
    };
    const flush = () => {
      const prevInserted = inserted;
      inserted = [];
      return prevInserted;
    };
    return {
      cache,
      flush
    };
  });
  useServerInsertedHTML(() => {
    const names = flush_0();
    if (names.length === 0) return null;
    let styles = "";
    for (const name of names) {
      styles += cache_0.inserted[name];
    }
    return <style key={cache_0.key} data-emotion={`${cache_0.key} ${names.join(" ")}`} dangerouslySetInnerHTML={{
      __html: styles
    }} />;
  });
  return <CacheProvider value={cache_0}>{children}</CacheProvider>;
}